"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _constants = require("../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const circleStyles = (0, _core.makeStyles)({
  root: {
    display: 'flex',
    height: 22,
    alignItems: 'center',
    width: '10px',
    flex: '0 0 auto'
  },
  circle: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: _constants.colours.wizardCircleButton,
    '&.active': {
      backgroundColor: _constants.colours.pink
    },
    '&:hover': {
      backgroundColor: _constants.colours.darkGrey
    }
  },
  completed: {
    color: 'blue',
    zIndex: 1,
    fontSize: 14,
    width: '100%'
  }
});

function CircleStepIcon({
  active,
  completed
}) {
  const classes = circleStyles();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: [classes.circle, active && 'active', completed && 'completed'].filter(e => !!e).join(' ')
  }));
}

CircleStepIcon.propTypes = {
  active: _propTypes.default.bool,
  completed: _propTypes.default.bool
};
CircleStepIcon.defaultProps = {
  active: false,
  completed: false
};
var _default = CircleStepIcon;
exports.default = _default;